export const SET_CURRENT_VENTURE_DOCUMENTS = "SET_CURRENT_VENTURE_DOCUMENTS"
export const SET_UPLOADING_PROGRESS_PERCENTAGE = "SET_UPLOADING_PROGRESS_PERCENTAGE"

